export class RequestVO<T> {
    page: number;
    size: number;
    orderBy: string;
    orderType: string;
    token: string;
    parameters: T;
}